export enum ApiEnum {
    WS_IT,
    WS_HCM,
    WS_AGR,
    WS_QM,
    WS_IND,
    WS_TRAZ,
    WS_TAG,
}